import { useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {

  const [formData, setFormData] = useState({
    banks: '',
    accountNumber: null,

  });

  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.banks === '' || formData.banks === null) {
      formErrors.banks = 'Bank cannot be empty';
    }

    if (formData.accountNumber === '' || formData.accountNumber === null) {
      formErrors.accountNumber = 'AccountNumber cannot be empty';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  const token = authServices.getToken();
  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/bank/add', formData, {

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {
        setFormData({
          banks: '',
          accountNumber: null,
        });
        toast.success(response.data.message);
      }
      else {
        toast.error(response.data.message);
        console.log(response.data.message)
      }
    }
    catch (error) {
      toast.error(error.response.data.message);
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle();
    }
  };
  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Bank</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className="row ">
                      <div className="spacing w-50 d-inline-block" >

                        <label htmlFor="banks" className="label-custom">Bank Name</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.banks ? 'input-error' : ''}`}
                          id="banks"
                          name="banks"
                          value={formData.banks}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="spacing w-50 d-inline-block" >

                        <label htmlFor="accountNumber" className="label-custom">Account Number</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.accountNumber ? 'input-error' : ''}`}
                          id="accountNumber"
                          name="accountNumber"
                          value={formData.accountNumber}
                          onChange={handleChange}
                          onInput={(e) => {
                            // Allow digits and a single decimal point
                            e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Only allow digits and dots
                            // Prevent more than one decimal point
                            if ((e.target.value.match(/\./g) || []).length > 1) {
                              e.target.value = e.target.value.replace(/\.+$/, '');
                            }
                          }}
                        />
                      </div>

                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
